module.exports = __webpack_public_path__ + "static/007-d22e87c311e990bc7564b7413086cf94.jpg";